import React, { useState } from 'react';

import { LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import Payment from '../../components/transaction/Payment/Payment';
import { useConfig } from '../../defaultConfig';
import usePaymentAccount from '../../hooks/usePaymentAccount';
import useTranslation from '../../hooks/useTranslation';

import './ImmediatePayment.scss';

const ImmediatePayment: React.FC = () => {
    const translated = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const { featureToggles } = useConfig();
    const paymentAccount = usePaymentAccount();

    if (!featureToggles.enableImmediatePayment) {
        return null;
    }

    return (
        <>
            <div className="immediate-payment">
                <LinkButton onClick={() => setShowModal(true)} icon={IconTypes.SNAPCASH_24}>
                    {translated.immediatePayment.title}
                </LinkButton>
            </div>
            {showModal && (
                <Payment show={showModal} setShow={setShowModal} isImmediatePaymentFlow account={paymentAccount} />
            )}
        </>
    );
};

export default ImmediatePayment;
